<template>
  <div>
    <h2>配信する地点グループを選んでください</h2>
    <v-layout class="mb-4">
      <v-flex offset-xs2 xs8>
        <CampaignModalPageGeoGroupSelect
          :oem-location-groups="menuSetting.oemLocationGroups"
          :advertiser-location-groups="menuSetting.advertiserLocationGroups"
          :insertion-order-location-groups="
            menuSetting.insertionOrderLocationGroups
          "
          :current-delivery-location-groups="
            menuSetting.visibleDeliveryLocationGroups
          "
          :simulation-location-groups="menuSetting.simulationLocationGroups"
          :loading="loadingLocationGroup"
          :isLimitOverDeliveryLocationGroups="
            menuSetting.isLimitOverDeliveryLocationGroups
          "
          @add="onAddDeliveryLocationGroups"
          @remove="onRemoveDeliveryLocationGroups"
          @select="onSelectDeliveryLocationGroups"
          @fetch="fetchLocationGroups"
        />
      </v-flex>
    </v-layout>
    <p style="color: red; font-size: small">
      ※ 地点カテゴリーのグループは、マップ上に地点を表示できません。
    </p>
    <v-layout class="mapWrapper">
      <CampaignModalPageGeoMap
        :delivery-location-groups="menuSetting.visibleDeliveryLocationGroups"
        :selected-location-groups="selectedDeliveryLocationGroups"
      />
    </v-layout>
  </div>
</template>

<script>
import 'mapbox-gl/dist/mapbox-gl.css'
import CampaignModalPageGeoMap from './CampaignModalPageGeoMap.vue'
import CampaignModalPageGeoGroupSelect from './CampaignModalPageGeoGroupSelect.vue'

export default {
  name: 'CampaignModalPageGeo',
  components: { CampaignModalPageGeoGroupSelect, CampaignModalPageGeoMap },
  props: {
    form: {
      type: Object,
      required: true,
    },
    systemOwner: {
      type: Object,
      required: true,
    },
    insertionOrder: {
      type: Object,
      required: true,
    },
    advertiser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      oemLocationGroups: [],
      advertiserLocationGroups: [],
      insertionOrderLocationGroups: [],
      loadingLocationGroup: false,
      selectedDeliveryLocationGroups: [],
    }
  },
  computed: {
    menuSetting() {
      return this.form.campaign.menuSetting
    },
    errorMessage() {
      const deliveryLocationGroupsCount = this.menuSetting
        .visibleDeliveryLocationGroups.length
      if (deliveryLocationGroupsCount === 0) {
        return '配信地点グループが1つも登録されていません。\n最低1つは地点グループを登録してください。'
      } else if (this.menuSetting.isLimitOverDeliveryLocationGroups) {
        return `現在、配信地点グループの設定上限を一時的に60グループまでとさせていただいております。
                61グループを超えて設定される場合、別途キャンペーンを作成して登録して下さい。
        選択した配信地点グループ数: ${deliveryLocationGroupsCount}`
      } else {
        return ''
      }
    },
  },
  created() {
    this.fetchLocationGroups()
  },
  methods: {
    onAddDeliveryLocationGroups(deliveryLocationGroups) {
      this.menuSetting.addDeliveryLocationGroups(deliveryLocationGroups)
    },
    onRemoveDeliveryLocationGroups(deliveryLocationGroups) {
      this.menuSetting.removeDeliveryLocationGroups(deliveryLocationGroups)
    },
    onChangeDeliveryLocationGroups(deliveryLocationGroups) {
      this.menuSetting.deliveryLocationGroups = deliveryLocationGroups
    },
    onSelectDeliveryLocationGroups(deliveryLocationGroups) {
      this.selectedDeliveryLocationGroups = deliveryLocationGroups
    },
    async fetchLocationGroups() {
      this.loadingLocationGroup = true
      await this.menuSetting.fetchLocationGroups()
      this.loadingLocationGroup = false
    },
  },
}
</script>

<style scoped>
.mapWrapper {
  width: 100%;
  height: 300px;
  position: relative;
}
</style>
